import { AfterViewInit, ChangeDetectorRef, Component, ElementRef, OnDestroy, ViewChild } from '@angular/core';
import { FieldType } from '@ngx-formly/material';
import { FieldTypeConfig } from '@ngx-formly/core';

@Component({
  selector: 'formly-field-custom-select',
  template: `
    <mat-select
      class="custom-select-input"
      [formControl]="formControl"
      [formlyAttributes]="field"
      (opened)="selectOpened()"
      (selectionChange)="to.change && to.change(field, $event)">
      <div class="sticky-input">
        <input
          matInput
          #filterInput
          placeholder="{{ 'general.typeToFilter' | translate }}"
          *ngIf="filter || $any(field.templateOptions.options).length >= 10"
          (input)="doFilter($event)"
          (keydown.space)="handleHostSpace($event)" />
      </div>

      <ng-container
        *ngIf="$any(field.templateOptions.options).length > 500; then hideOptions; else showAll"></ng-container>

      <ng-template #hideOptions>
        <mat-option disabled="true" class="hint">{{ 'general.typeToFilterHint' | translate }}</mat-option>
      </ng-template>

      <ng-template #showAll>
        <mat-option *ngFor="let item of field.templateOptions.options" [value]="item.value">
          <!-- TODO: shit happens -->
          <b class="hide">‎</b>{{ item.label }}
        </mat-option>
      </ng-template>
    </mat-select>
  `,
  styleUrls: ['custom-select-type.component.scss'],
})
export class FormlyFieldCustomSelectComponent extends FieldType<FieldTypeConfig> implements AfterViewInit, OnDestroy {
  @ViewChild('filterInput', { static: false })
  filterInput: ElementRef;

  filter: string;
  selectOptions: any[];

  constructor(private cdRef: ChangeDetectorRef) {
    super();
  }

  handleHostSpace(event: Event) {
    event.stopPropagation();
  }

  ngAfterViewInit() {
    this.selectOptions = this.field.templateOptions.options as any[];
    this.cdRef.detectChanges();
  }

  ngOnDestroy() {
    super.ngOnDestroy();
  }

  doFilter(event) {
    this.filter = event.target.value.toLowerCase();
    this.field.templateOptions.options = this.filter.length
      ? this.selectOptions.filter((item) => item.label.toLowerCase().includes(this.filter))
      : this.selectOptions;
  }

  selectOpened() {
    if (this.filterInput) {
      this.filterInput.nativeElement.focus();
    }
  }
}
